export default __webpack_public_path__ + "static/media/750x750 orangeCat.2af17c42.jpg";